import { SyntheticEvent } from 'react';

export enum PanelSize {
  FullWidth = 'fullWidth', // 100vw
  Xlarge = 'xlarge', // calc(100vw - ${spacing.x4})
  Large = 'large', // 928px
  Medium = 'medium', // 672px
  Small = 'small', // 525px
}

export interface TakeOverProps {
  className?: string;
  /** Takeover panel header */
  Header?: React.ReactNode;
  /** Takeover panel footer */
  Footer?: React.ReactNode;
  /** Take Over Nav bar */
  NavBar?: React.ReactNode;
  /** Take Over Overlay */
  Overlay?: React.ReactNode;
  /** One of the pre-defined sizes for the TakeOver component */
  size?: PanelSize;
  /** Whether the Take Over should be rendered in a portal */
  withPortal?: boolean;
  /** Callback when the takeover is closed */
  onClose?: (e?: SyntheticEvent) => void;
}
